
import { AxiosRequestConfig } from 'axios';

const updateHeaderInterceptor = async (http: any) => {

  http.interceptors.request.use(async (config: AxiosRequestConfig) => {
    const token = '';
    const formattedToken = token ? `Bearer ${token}` : undefined;
    if (formattedToken) {
      config.headers!['Authorization'] = formattedToken;
    }

    return config;
  })
}

export default updateHeaderInterceptor;
